<template>
  <div class="account-setting-basic">
    <div class="account-setting-basic__top">
      <a-button type="primary">编辑</a-button>
    </div>
    <description-list :gutter="16" title="基本信息" maxWidth="800px">
      <description-list-item label="头像" labelWidth="70px" labelLineHeight="100px">
        <a-avatar :src="detail.avatar" :size="100" />
      </description-list-item>
      <description-list-item label="姓名" labelWidth="70px" :content="detail.name" :span="12" />
      <description-list-item
        label="性别"
        labelWidth="70px"
        :content="detail.gender === 1 ? '男' : '女'"
        :span="12"
      />
      <description-list-item
        label="用户名"
        labelWidth="70px"
        :content="detail.username"
        :span="12"
      />
      <description-list-item label="地址" labelWidth="70px" :content="detail.address" :span="12" />
      <description-list-item label="个人简介" labelWidth="70px" :content="detail.intro" />
    </description-list>
  </div>
</template>

<script>
import DescriptionList from '@/components/DescriptionList';
import { getUserById } from '@/services/common';

export default {
  components: {
    DescriptionList,
    DescriptionListItem: DescriptionList.Item,
  },
  data() {
    return {
      detail: {},
    };
  },
  mounted() {
    getUserById(1).then((res) => {
      this.detail = res;
    });
  },
};
</script>

<style lang="less" scoped>
.account-setting-basic {
  height: 100%;
  padding: @padding-lg;
  background: white;
  border-radius: @border-radius-base;
  box-shadow: @box-shadow-base;
  &__top {
    margin-bottom: @padding-lg;
  }
}
</style>
